import { render } from "./AccountBilling.vue?vue&type=template&id=7022ad6f&scoped=true"
import script from "./AccountBilling.vue?vue&type=script&lang=js"
export * from "./AccountBilling.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7022ad6f"

export default script